import { getApp } from './App';

/**************************************************************************************************************
/* Segments
/*************************************************************************************************************/
export const addSegment = segment => dispatch => {
  dispatch(addSegments([segment]));
};

export const editSegment = segment => ({
  type: 'UPDATE_SEGMENT',
  segment,
});

export const deleteSegment = segmentId => ({
  type: 'DELETE_SEGMENT',
  segmentId,
});

export const addSegments = segments => ({
  type: 'ADD_SEGMENTS',
  segments,
});

/**************************************************************************************************************
/* Activities
/*************************************************************************************************************/
export const addActivity = (activity, numActivities = 1) => (dispatch, getState) => {
  if (activity.error) {
    // we can't load this activity so add an error but continue with the rest of the process
    dispatch(setMessage('getActivityError'));
    return;
  }

  // Add the activity to the state
  dispatch({ type: 'ADD_ACTIVITY', activity, numActivities, scene: getState().scene });

  getApp().onActivityAdded(getState().activities[activity.activityId]);
};

export const toggleActivityVisibility = activityId => ({
  type: 'TOGGLE_ACTIVITY_VISIBILITY',
  activityId,
});

export const deleteActivity = activityId => (dispatch, getState) => {
  if (getState().tracks.activeTrack === activityId) {
    console.warn('Cannot delete activeTrack');
    return;
  }

  getApp().onActivityDeleted(activityId);

  // Then the activity
  dispatch({ type: 'DELETE_ACTIVITY', activityId });
};

// Set the active track, and the profile track if necessary
export const setActiveActivity = targetId => ({
  type: 'SET_ACTIVE_TRACK',
  trackId: targetId,
});

/**************************************************************************************************************
/* Clock
/*************************************************************************************************************/
export const togglePlaying = () => ({
  type: 'TOGGLE_PLAYING',
});

export const stopPlaying = () => ({
  type: 'STOP_PLAYING',
});

export const startPlaying = () => ({
  type: 'START_PLAYING',
});

export const setClockSpeed = speed => ({
  type: 'SET_SPEED',
  speed,
});

export const setTime = time => ({
  type: 'SET_TIME',
  time,
});

export const setClockStartTime = startTime => ({
  type: 'SET_START_TIME',
  startTime,
});

export const setClockStopTime = stopTime => ({
  type: 'SET_STOP_TIME',
  stopTime,
});

/**************************************************************************************************************
/* Messages
/*************************************************************************************************************/
export const setMessage = message => ({
  type: 'SET_MESSAGE',
  message,
});

export const clearMessage = messageId => ({
  type: 'CLEAR_MESSAGE',
  messageId,
});

/**************************************************************************************************************
/* Options
/*************************************************************************************************************/
export const setTrailLength = trailLength => ({
  type: 'SET_TRAIL_LENGTH',
  trailLength,
});

export const setUnits = units => ({
  type: 'SET_UNITS',
  units,
});

export const toggleControls = showControls => ({
  type: 'TOGGLE_CONTROLS',
  showControls,
});

export const setCameraDistance = distance => ({
  type: 'SET_CAMERA_DISTANCE',
  distance,
});
